import {
  secureBusinessSectionsVulcan,
  secureBusinessPlanVulcan
} from '../../../utils/constant';

export const secureBusinessPlan = secureBusinessPlanVulcan;
export const secureBusinessOffersVulcan = 'secureBusinessOffersVulcan';
export const optionSecureBusiness = 'Telus Secure Business';
export const pricingFields = [
  secureBusinessOffersVulcan,
  secureBusinessPlanVulcan
];

export const setPricingFields = formFields => {
  const addedFields = new Set(pricingFields);
  if (formFields) {
    secureBusinessSectionsVulcan.forEach(section => {
      const sectionFields = formFields[section];
      if (sectionFields) {
        Object.values(sectionFields).forEach(field => {
          if (field.name && !addedFields.has(field.name)) {
            pricingFields.push(field.name);
            addedFields.add(field.name);
          }
        });
      }
    });
  }
};
